import { render, staticRenderFns } from "./MultiOptionsField.vue?vue&type=template&id=192fb8f0&scoped=true"
import script from "./MultiOptionsField.vue?vue&type=script&lang=ts"
export * from "./MultiOptionsField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192fb8f0",
  null
  
)

export default component.exports